const PATH = '/symbol';
const SymbolService = {
    async findMatch(symbols) {

        return axios.get(`${PATH}/match/${symbols.join(',')}`);
    }
}

export default SymbolService;
